import OfficeExpense from "../../../../components/company/expense/office-expense";

export default function OfficeExpensePage (){
    return <OfficeExpense/>;
}